/**
 * Campaign search field helpers for Firestore prefix search.
 * Used when creating/updating campaigns to keep _searchInternalName and _searchTitle in sync.
 */

/**
 * Compute lowercase search fields from campaign data.
 * @param {Object} campaign - Campaign data with internalName, options.title
 * @returns {{ _searchInternalName: string, _searchTitle: string }}
 */
export function getCampaignSearchFields(campaign) {
  const internalName = (campaign?.internalName || campaign?.name || '').toString().trim();
  const title = (campaign?.options?.title || '').toString().trim();
  return {
    _searchInternalName: internalName.toLowerCase(),
    _searchTitle: title.toLowerCase(),
  };
}
